/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import PropTypes from 'prop-types'

import { values } from 'lodash'
import classes from 'classnames'

import { ui } from '../redux'

const Toast = ({ title, intent, message, onClose }) => (
    <div className={ classes('gritter-item-wrapper', 'color', intent) } role="alert">
        <div className="gritter-item">
            <div className="gritter-content gritter-without-image">
                <a role="button" className="gritter-close" onClick={ onClose }>x</a>
                <span className="gritter-title">{ title }</span>
                <p>{ message }</p>
            </div>
        </div>
    </div>
)

Toast.propTypes = {
    title   : PropTypes.string.isRequired,
    message : PropTypes.string.isRequired,
    intent  : PropTypes.oneOf(values(ui.INTENT)).isRequired,
    onClose : PropTypes.func.isRequired
}

export default Toast
